import { render, staticRenderFns } from "./upload2.vue?vue&type=template&id=befc8e38&scoped=true&"
import script from "./upload2.vue?vue&type=script&lang=js&"
export * from "./upload2.vue?vue&type=script&lang=js&"
import style0 from "./upload2.vue?vue&type=style&index=0&id=befc8e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc8e38",
  null
  
)

export default component.exports